'use strict';

const hoek = require('hoek');
const join = require('path').join;
const process = require('./process.js');

const defaultOptions = {
  rootDirectory: 'root',
  cacheUrl: '/cache',
};

function register(server, options, next) {
  options = hoek.applyToDefaults(defaultOptions, options, true);
  options.cacheDirectory = options.cacheDirectory || join(options.rootDirectory, 'cache');

  process(options.rootDirectory, options.cacheDirectory, options.cacheUrl)
    .then(function (checksums) {
      function urlFor(url) {
        const file = url.slice(1);
        const checksum = checksums[file];
        return !options.development && checksum ? `${options.cacheUrl}/${checksum}/${file}` : url;
      }
      server.method('urlFor', urlFor);
      next();
    }, next);
}

register.attributes = {
  pkg: require('../package.json'),
};

exports.register = register;
